<!-- src/components/NotificationManager.vue -->
<template>
    <div class="notification-manager" v-if="hasNotifications">
        <div class="scroll-container">
            <div class="notifications-container">
                <transition-group name="notification-list"
                                  move-class="notification-move"
                                  @mouseenter="handleMouseEnter"
                                  @mouseleave="handleMouseLeave"
                                  appear>
                    <!-- ���� appear ���� -->
                    <Notification v-for="msg in messages"
                                  :key="msg.id"
                                  :message="msg.text"
                                  :type="msg.type"
                                  :id="msg.id"
                                  @dismiss="dismiss(msg.id)" />
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
    import Notification from './Notification.vue';

    export default {
        components: {
            Notification
        },
        data() {
            return {
                messages: [],
                isHovering: false
            };
        },
        computed: {
            hasNotifications() {
                return this.messages.length > 0;
            }
        },
        methods: {
            addMessage(message, type = 'info') {
                const id = Date.now() + Math.random().toString(36).substr(2, 5);
                this.messages.unshift({ id, text: message, type });

                if (!this.isHovering) {
                    this.$nextTick(() => {
                        const container = this.$el?.querySelector('.scroll-container');
                        if (container) {
                            container.scrollTop = 0;
                        }
                    });
                }
            },
            dismiss(id) {
                this.messages = this.messages.filter(msg => msg.id !== id);
            },
            handleMouseEnter() {
                this.isHovering = true;
            },
            handleMouseLeave() {
                this.isHovering = false;
            }
        }
    };
</script>

<style scoped>
    .notification-manager {
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 10000;
    }

    .scroll-container {
        max-height: min(90vh, 1000px); /* �������߶����� */
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 8px;
        scrollbar-width: thin;
        scrollbar-color: #c1c1c1 transparent;
    }

        /* �Զ����������ʽ */
        .scroll-container::-webkit-scrollbar {
            width: 8px;
        }

        .scroll-container::-webkit-scrollbar-track {
            background: rgba(0, 0, 0, 0.05);
            border-radius: 4px;
        }

        .scroll-container::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.2);
            border-radius: 4px;
        }

            .scroll-container::-webkit-scrollbar-thumb:hover {
                background: rgba(0, 0, 0, 0.3);
            }

    .notifications-container {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 20px;
        min-width: 100px;
        max-width: min(400px,70vw);
        /* �����ڱ߾���Ϊ�Ŵ󻺳��� */
        padding: 0px 0px 50px 30px;
        margin: 0px 0px; /* ���߾�����ڱ߾�Բ��ֵ�Ӱ�� */
        box-sizing: border-box;
    }

    /* �ƶ�����Ч�� */
    .notification-move {
        transition: all 0.5s cubic-bezier(0.25, 0.8, 0.5, 1);
    }

    /* �б������/�뿪���� */
    .notification-list-enter-active,
    .notification-list-leave-active {
        transition: all 0.5s ease;
    }

    .notification-list-enter-from,
    .notification-list-leave-to {
        opacity: 0;
        transform: translateX(50px);
    }

    /* ȷ���뿪����ʹ�þ��Զ�λ */
    .notification-list-leave-active {
        position: absolute !important;
        right: 0;
    }

    /* �Ż��������� */
    .notification-list-move {
        transition: all 0.5s ease;
    }

    .notification-list-appear-active,
    .notification-list-enter-active {
        transition: all 0.5s ease;
    }

    .notification-list-appear-from,
    .notification-list-enter-from {
        opacity: 0;
        transform: translateX(50px);
    }
</style>